<template>
    <ModalComponent
        :name="'cambiar-asiento-' + abonado.id"
        :title="'Cambiar asiento ' + abonado.name + ' ' + abonado.surnames"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <span class="h3"><b>Información del abonado</b></span>
            </div>
            <div class="col-12">
                <ul>
                    <li>
                        <b>Nº de abonado:</b> {{ abonado.n_abonado }}
                    </li>
                    <li>
                        <b>Nombre:</b> {{ abonado.name }}
                    </li>
                    <li>
                        <b>Apellidos:</b> {{ abonado.surnames }}
                    </li>
                    <li>
                        <b>Zona:</b> {{ abonado.asiento.region }}
                    </li>
                    <li>
                        <b>Fila:</b> {{ abonado.asiento.row }}
                    </li>
                    <li>
                        <b>Butaca:</b> {{ abonado.asiento.seat }}
                    </li>
                </ul>
            </div>
            <div class="col-12">
                <span class="h3"><b>Selecciona una zona</b></span> <span class="h5">Al hacer click en el asiento este se cambiará</span>
            </div>
            <div class="col-12 mt-3">
                <div class="form-group" v-if="zonas">
                    <select class="form-control" name="zona" id="zona" v-model="new_zona" @change="getAsientos">
                        <template v-for="(zona, index) in zonas">
                            <option :key="index" :value="zona">{{ zona.name }}</option>
                        </template>
                    </select>
                </div>
                <template v-else>
                    <LoaderComponent></LoaderComponent>
                </template>
            </div>
            <div class="col-12" v-if="new_zona">
                <div class="container-butacas-wrapper" v-if="!loading">
                    <div :class="'container-butacas text-align-' + new_zona.print_align">
                        <template v-if="new_zona && new_zona.with_seats">
                            <template v-for="(butacas, fila) in filas">
                                <span :key="fila">
                                    <span class="fila">{{ fila }}</span>
                                    <template v-for="(asiento, index) in butacas">
                                        <AsientoComponent 
                                            :asiento="asiento" 
                                            :fila="fila" 
                                            :key="index" 
                                            @toggle="() => toggleSeleccion(fila, asiento.asiento, asiento.ocupado)"
                                        />
                                    </template>
                                    <br />
                                </span>
                            </template>
                        </template>
                    </div>
                </div>
                <template v-else>
                    <LoaderComponent></LoaderComponent>
                </template>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";

export default {
    props: ['abonado'],
    data() {
        return {
            new_zona: null,
            loading: false,
            zonas: null,
            filas: null
        }
    },
    created() {
        this.getZonas();
    },
    methods: {
        close(sancionado) {
            this.$emit('close', this.abonado.id);
        },
        getZonas() {
            this.$store.dispatch(this.config.getVuexAlias('zonas.index')).then(res => {
                this.zonas = res.data;
            });
        },
        getAsientos() {
            if(!this.new_zona.with_seats) {
                this.toggleSeleccion(0, 0, 0);
            } else {
                this.loading = true;
                var params = null;
                params = {
                    filters: {
                        zona_id: this.new_zona.id,
                        conf: true
                    },
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.filas = res.data.configuracion_asientos;
                    this.precios = res.data.precios;
                    this.loading = false;
                });
            }
        },
        toggleSeleccion(fila, asiento, ocupado) {
            this.loading = true;

            const params = {
                row: fila,
                region_id: this.new_zona.id,
                id: this.abonado.id,
                abonado_id: this.abonado.id,
                seat: asiento
            };
            if (ocupado == 0) {
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.asiento'), params).then(res => {
                    this.loading = false;
                    this.$emit('asientoEditado');
                }).catch(error => {
                    this.$toast.error('El asiento esta ocupado');
                    this.loading = false;
                });
            } else {
                this.$toast.error('El asiento esta ocupado');
                this.loading = false;
            }
        }
    },
    components: {
        ModalComponent, AsientoComponent
    }
}
</script>
